import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import VideoPlayer from '../VideoPlayer'
import {
  getVideoData,
  getAccountSettings,
  setUserStatus,
  openDoor,
} from '../../actions/sessionActions'
import Navbar from '../nav/Navbar'
import { Container, Row, Col } from 'reactstrap'
import HomeHeader from './HomeHeader'
import Loader from 'react-loader'

class HomePage extends Component {
  state = {
    status: this.props.status,
    isOpen: false,
  }

  componentDidMount() {
    this.props.getVideoData()
    this.props.getAccountSettings()
  }

  onClick = () => {
    if (this.state.isOpen) return
    this.props.openDoor()
    this.setState({ isOpen: !this.state.isOpen })
    setTimeout(() => {
      this.setState({ isOpen: !this.state.isOpen })
    }, 5000)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.currentUser &&
      nextProps.currentUser.state !== prevState.status
    ) {
      nextProps.setUserStatus(nextProps.currentUser.state)
      return {
        status: nextProps.currentUser.state,
      }
    }
    return prevState
  }

  render() {
    if (!this.props.jwt) {
      return <Redirect to="/login" />
    } else {
      return (
        <div>
          <Navbar loggedIn={this.props.status === 'activated' ? true : false} />
          <Container className="d-flex justify-content-center flex-column h-100 w-100">
            <Loader
              loaded={
                this.props.videoData && this.props.videoData.length > 1
                  ? true
                  : false
              }
            >
              <Row className="align-items-center justify-content-center h-100 ">
                <Col md={{ size: 12 }}>
                  <HomeHeader
                    onClick={this.onClick}
                    isOpen={this.state.isOpen}
                    text={
                      this.props.currentUser &&
                      this.props.currentUser.full_address
                    }
                    loggedIn={this.props.status === 'activated'}
                  />
                </Col>
              </Row>
              <Row className="align-items-center justify-content-center h-100">
                <Col md={{ size: 12 }}>
                  <VideoPlayer
                    videoUrl={this.props.videoData}
                    loaded={
                      this.props.videoData && this.props.videoData.length > 0
                    }
                  />
                </Col>
              </Row>
            </Loader>
          </Container>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  jwt: state.session.jwt,
  videoData: state.ui.videoData,
  status: state.session.userStatus,
  currentUser: state.session.currentUser,
})

export default connect(mapStateToProps, {
  getVideoData,
  getAccountSettings,
  openDoor,
  setUserStatus,
})(HomePage)



// WEBPACK FOOTER //
// ./src/components/home/HomePage.js